// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-title {
  font-size: 28px;
  font-weight: 700;
  line-height: 36px;
  text-align: center;

  margin: 20px auto 40px;
}

/* desktop */
@media (min-width: 1920px) {
  .page-title {
    font-size: 32px;
    line-height: 48px;
  }
}

.page-title.uppercase {
  text-transform: uppercase;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.title.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;;EAElB,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".page-title {\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 36px;\n  text-align: center;\n\n  margin: 20px auto 40px;\n}\n\n/* desktop */\n@media (min-width: 1920px) {\n  .page-title {\n    font-size: 32px;\n    line-height: 48px;\n  }\n}\n\n.page-title.uppercase {\n  text-transform: uppercase;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
